import { createAction } from "@reduxjs/toolkit";
import { CHECK_LOGIN, LOGOUT } from "./types";

export const logout = createAction(LOGOUT);

export const checkLogin = createAction(CHECK_LOGIN);
